import slice, { fetchAreas } from './area.slice';
export { fetchAreas };
export default slice.reducer;
